var _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _path8, _rect9, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleGeneralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 78,
    viewBox: "0 0 45 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3619 0.182617H27.4946V4.44904H17.3619V0.182617ZM27.4968 4.44925H31.7632V8.71567H27.4968V4.44925ZM36.0287 8.71588H31.7623V12.9823H36.0277V17.2486H40.2942V12.9821H36.0287V8.71588ZM44.5627 17.2488H40.2963V33.7812H44.5627V17.2488ZM13.0964 4.44925H17.3628V8.71567H13.0964V4.44925ZM13.0973 8.71588H8.83091V12.9823H13.0973V8.71588ZM4.56235 12.9821H8.82878V17.2486H4.56235V12.9821ZM8.82878 33.7815H4.56235V38.0479H8.82878V33.7815ZM17.3638 44.4479V48.7143H8.83091V44.4479H17.3638ZM17.3638 73.2466V68.9802H8.83091V73.2466H17.3638ZM17.3619 73.2468H27.4946V77.5132H17.3619V73.2468ZM36.0296 73.2466V68.9802H27.4968V73.2466H36.0296ZM4.56235 48.7141H8.82878V52.9806H4.56235V48.7141ZM8.82878 64.7135H4.56235V68.9799H8.82878V64.7135ZM31.7623 48.7143H36.0277V52.9806H40.2942V48.7141H36.0287V44.4479H31.7634V42.3146H33.8967H40.2963V38.0481H27.497V48.7142H31.7623V48.7143ZM40.2942 64.7135H36.0277V68.9799H40.2942V64.7135ZM40.2942 33.7815H36.0277V38.0479H40.2942V33.7815ZM4.5633 17.2488H0.296875V33.7812H4.5633V17.2488ZM0.296875 52.9808H4.5633V64.7134H0.296875V52.9808ZM44.5627 52.9808H40.2963V64.7134H44.5627V52.9808Z",
    fill: "#190D11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.495 4.44922H17.362V8.71573H13.0955V12.9822H8.82902V17.2488H4.5625V33.7815H8.82902V38.048H17.362V48.7143H8.82902V52.8964H4.5625V64.7137H8.82902V68.9803H17.362V73.2468H27.495V68.9803H36.028V64.7137H40.2946V52.9808H36.028V48.7143H27.495L27.4223 38.048H36.028V33.7815H40.2946V17.2488H36.028V12.9822H31.7615V8.71573H27.495V4.44922Z",
    fill: "#8FB569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.028 48.7139H27.495H17.362H8.82902V52.8959H4.5625V64.7133H8.82902V68.9798H17.362V73.2463H27.495V68.9798H36.028V64.7133H40.2946V52.9804H36.028V48.7139Z",
    fill: "#FFB800"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.0938,
    y: 12.9824,
    width: 4.26643,
    height: 4.26643,
    fill: "#F0EFE9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0938,
    y: 25.7812,
    width: 4.26643,
    height: 4.26643,
    fill: "#F0EFE9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.36328,
    y: 21.5146,
    width: 7.99955,
    height: 4.26643,
    fill: "#F0EFE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9608 12.9824H36.0272V17.2489H40.2937V33.7817H36.0272V38.0482H27.4941V48.7145H25.3609V52.981H17.3612V38.0482H13.0946V42.3147H8.82812V33.7817H17.8945V36.4483H22.161V33.2484H26.9608V28.9819H31.7606V20.4488H26.9608V12.9824Z",
    fill: "#327220"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0938,
    y: 48.7139,
    width: 4.26643,
    height: 4.26643,
    fill: "#FFD582"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3594,
    y: 48.7139,
    width: 7.99955,
    height: 4.26643,
    fill: "#190D11"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82812,
    y: 56.1807,
    width: 5.33303,
    height: 4.26643,
    fill: "#FFD582"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0938,
    y: 64.7139,
    width: 11.7327,
    height: 4.26643,
    transform: "rotate(-90 21.0938 64.7139)",
    fill: "#DB954C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3594,
    y: 64.7139,
    width: 4.26643,
    height: 3.73312,
    transform: "rotate(-90 17.3594 64.7139)",
    fill: "#DB954C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.025 48.7139H25.3589V64.713H17.3594V73.2458H27.4921V68.9794H36.025V64.713H40.2914V52.9803H36.025V48.7139Z",
    fill: "#BF6717"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82812 38.0479H17.361V42.3143H8.82812V38.0479Z",
    fill: "#190D11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6289 38.0479L21.6289 48.7139L17.3625 48.7139L17.3625 38.0479L21.6289 38.0479Z",
    fill: "#265C1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4961 42.8477L27.4961 48.714L21.6298 48.714L21.6298 42.8477L27.4961 42.8477Z",
    fill: "#265C1B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3594,
    y: 44.4482,
    width: 4.26643,
    height: 4.26643,
    fill: "#9BBC3D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0273,
    y: 64.7139,
    width: 11.7327,
    height: 4.26643,
    transform: "rotate(-90 36.0273 64.7139)",
    fill: "#87480D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleGeneralIcon);
export default __webpack_public_path__ + "static/media/role_general_icon.f364540ce830471eea8723131d834fe2.svg";
export { ForwardRef as ReactComponent };